/* 合并导出 */
<template>
  <Modal
    v-model="visible"
    class="merge-export"
    width="550"
    :mask-closable="false"
  >
    <div class="title" slot="header">合并导出以下修改单文件</div>
    <div class="main">
      <CheckboxGroup v-model="social" >
        <Checkbox
          v-if="orderModifyList && orderModifyList.length > 0"
          v-for="(item, index) in orderModifyList"
          :key="index"
          style="margin-bottom:20px;width:100%;"
          :label="item.id"
        >
          <Row
            class="main-item"
            :gutter="5"
            type="flex"
            justify="center"
            align="middle"
          >
            <Col span="8" class="ellipsis">{{ item.name }}</Col>
            <Col span="11" class="code ellipsis">编号{{ item.code }}</Col>
            <Col span="5"
              ><Tag
                :color="getConfirmText(item.confirmed).tag"
                class="tag-radius"
                >{{ getConfirmText(item.confirmed).txt }}</Tag
              ></Col
            >
          </Row>
        </Checkbox>
      </CheckboxGroup>
    </div>
    <div slot="footer" class="footer">
      <Button @click="cencel">&nbsp;&nbsp;&nbsp;取消 &nbsp;&nbsp;&nbsp;</Button>
      <Button type="primary" class="red-btn" @click="exportPrimary"
        >&nbsp;&nbsp;&nbsp;&nbsp;导出 &nbsp;&nbsp;&nbsp;&nbsp;</Button
      >
    </div>
  </Modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      orderModifyList: "",
      social: []
    };
  },
  methods: {
    open(orderModifyList) {

      if(!orderModifyList) return false;
      let newArray = [];
      orderModifyList.forEach((item) => {
        if(item.confirmed < 2) {
          newArray.push(item);
        }
      })
      if(newArray.length === 0) {
        this.$Message.error('暂时还没有可以导出的文件！');
        return false;
      };

      this.orderModifyList = newArray;
      if (this.orderModifyList && this.orderModifyList.length === 1) {
        this.social.push(this.orderModifyList[0].id);
      }
      
      this.visible = true;
    },
    cencel() {
      this.visible = false;
    },
    getConfirmText(confirmed) {
      switch (confirmed) {
        case 0:
          return { txt: "待确认", tag: "red" };
          break;
        case 1:
          return { txt: "已确认", tag: "cyan" };
          break;
        case 2:
          return { txt: "已取消", tag: "default" };
          break;
      }
    },
    /* 导出询价单 */
    exportPrimary() {
      if (!this.social || this.social.length === 0) {
        this.$Message.error("请选择要导出的修改单");
        return false;
      }
      this.visible = false;
      this.$emit("exportPrimaryHandle", this.social);
    }
  }
};
</script>

<style lang="scss" scoped>
.merge-export {
  .title {
    font-weight: 500;
    font-size: 20px;
  }
  .main {
    .main-item {
      margin-top: -2px;
      width: 91%;
      float: right;
      vertical-align: middle;
      .code {
        font-size: 12px;
        color: #707070;
      }
    }
  }
}
</style>
